import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Swal from 'sweetalert2';
import CryptoJS from 'crypto-js';
import { useNavigate } from 'react-router-dom';
import { API_URL, customStyles, secret_key, storedData } from './Constants';
import loadingGif from "../assets/loading.gif"
//import './Events.css'; // reuse your existing styles

const Events = () => {
  const navigate = useNavigate();

  // --- Decrypt Token & User Data ---
  const encryptedToken = localStorage.getItem('token');
  let decryptedToken = '';
  if (encryptedToken) {
    try {
      const bytes = CryptoJS.AES.decrypt(encryptedToken, secret_key);
      decryptedToken = bytes.toString(CryptoJS.enc.Utf8);
    } catch (error) {
      console.error('Token decryption error:', error);
    }
  }

  
  let newdecryptedToken = decryptedToken.trim();
  const token = `Bearer ${newdecryptedToken}`;

  let loggedUserData = null;
  if (storedData) {
    const bytes = CryptoJS.AES.decrypt(storedData, secret_key);
    loggedUserData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
  }

  // --- State ---
  const [loading, setLoading] = useState(false);
  const [events, setEvents] = useState([]);
  // --- Fetch Events Linked to Parent ---
const fetchEvents = async () => {
  if (!loggedUserData) return;

  setLoading(true);

  try {
    const res = await axios.get(
      `${API_URL}/events/${loggedUserData.company_id}/${loggedUserData.parent_no}`,
      {
        headers: {
          Authorization: `CustomToken ${secret_key}`,
        },
      }
    );

    if (res.data.success) {
      setEvents(res.data.details || []);
    } else {
      Swal.fire("Info", res.data.message || "No linked events found", "info");
    }

  } catch (err) {
    console.error("Fetch events error:", err);

    const backendMessage =
      err?.response?.data?.message ||
      err?.response?.data?.error ||
      JSON.stringify(err?.response?.data);

    const status = err?.response?.status || "No status";

    Swal.fire({
      title: "API Error",
      html: `
        <p><b>Status:</b> ${status}</p>
        <p><b>Message:</b> ${backendMessage}</p>
        <p><b>CustomToken Sent:</b> ${secret_key}</p>
      `,
      icon: "error",
      width: "600px",
    });

  } finally {
    setLoading(false);
  }
};


  useEffect(() => {
    fetchEvents();
  }, []);
  // --- Format Currency ---
  const formatCurrency = (val) =>
    new Intl.NumberFormat('en-KE', {
      style: 'currency',
      currency: 'KES',
    }).format(val || 0);


  return (
  <div className="dashboard-container container-fluid position-relative">

    {/* Loading Overlay */}
    {loading && (
      <div className="loading-overlay d-flex align-items-center justify-content-center">
        <img className="loading-img" src={loadingGif} alt="Loading..." />
      </div>
    )}

    {/* Page Header */}
    <header className="dashboard-header py-3 mb-4 border-bottom">
      <div className="d-flex justify-content-between align-items-center">
        <h1 className="fw-bold mb-0">
          <i className="fas fa-calendar-alt me-2 text-primary"></i>
          Events
        </h1>

        <nav aria-label="breadcrumb">
          <ol className="breadcrumb mb-0">
            <li className="breadcrumb-item"><a href="/">Home</a></li>
            <li className="breadcrumb-item active">Events</li>
          </ol>
        </nav>
      </div>
    </header>

    <div className="row">
      {/* --- Events Table --- */}
      <div className="col-lg-8">

        <div className="card shadow-md rounded-4 border-0 mb-4">
          <div className="card-header bg-gradient-primary text-white rounded-top-4 py-3 d-flex align-items-center">
            <h5 className="mb-0">
              <i className="fas fa-list-alt me-2"></i>
              All Events
            </h5>
          </div>

          <div className="card-body p-0">
            <div className="table-responsive rounded-bottom-4">
              <table className="table table-hover align-middle mb-0">
                <thead className="table-light">
                  <tr>
                    <th style={{ width: "30%" }}>Event Name</th>
                    <th>Location</th>
                    <th>Date</th>
                    <th>Time</th>
                  </tr>
                </thead>

                <tbody>
                  {events.length > 0 ? (
                    events.map((ev, i) => (
                      <tr key={i} className="event-row">
                        <td className="fw-semibold text-dark">{ev.event_name}</td>
                        <td className="text-muted">{ev.location}</td>

                        {/* Date */}
                        <td>
                          <span className="badge bg-light text-dark border px-3 py-2 rounded-pill">
                            {new Date(ev.start_date).toLocaleDateString()}
                          </span>
                        </td>

                        {/* Time Range */}
                        <td>
                          <span className="badge bg-primary text-white px-3 py-2 rounded-pill">
                            {ev.start_time} - {ev.end_time}
                          </span>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="4" className="text-center text-muted py-4">
                        <i className="fas fa-calendar-times fa-lg d-block mb-2"></i>
                        No events found.
                      </td>
                    </tr>
                  )}
                </tbody>

              </table>
            </div>
          </div>
        </div>
      </div>

      {/* --- Notes / Sidebar --- */}
      <div className="col-lg-4">
        <div 
          className="card shadow-lg sticky-top border-0 rounded-4" 
          style={{ top: "80px" }}
        >
          <div className="card-header bg-gradient-secondary text-white rounded-top-4 py-3">
            <h5 className="mb-0">
              <i className="fas fa-info-circle me-2"></i>
              Notes
            </h5>
          </div>

          <div className="card-body">
            <p className="text-muted mb-3">
              This section lists all scheduled events including date, start time, and end time.
            </p>

            <div className="alert alert-info rounded-3 small">
              <i className="fas fa-lightbulb me-2"></i>
              Tip: Keep event details clear and descriptive for better attendee experience.
            </div>

          </div>
        </div>
      </div>
    </div>

  </div>
);

};

export default Events;
